/**
 * @ngdoc Const
 * @name DataAttribute
 */
(function() {
    'use strict';

    angular.module('vrm.core')
        .constant('dataAttribute', dataAttribute);

    /**
     * @constructor
     */
    var dataAttribute = {
        'Battery_State_of_Charge' : 'bs'
    }

})();
